import { throwError as observableThrowError, Observable, of } from 'rxjs';

export class BaseApiService {
  constructor() { }
  protected handleError(error: any) {
    const applicationError = error.headers.get('Application-Error');
    const bodyContentError = error;
    // either applicationError in header or model error in body
    if (applicationError) {
      return observableThrowError(applicationError);
    }
    if (bodyContentError) {
      let errorContent;
      if (
        bodyContentError.error &&
        bodyContentError.error.Errors &&
        bodyContentError.error.Errors.length
      ) {
        let messages;
        messages = bodyContentError.error.Errors.map(err => {
          return ' ' + err.Description;
        });
        errorContent = {
          statusCode: bodyContentError.status,
          message: messages.toString()
        };
      } else if (
        bodyContentError.status === 401 &&
        bodyContentError.error &&
        bodyContentError.error.status &&
        !bodyContentError.error.verified &&
        bodyContentError.error.status === 'ACCESSTOKEN_EXPIRED'
      ) {
        errorContent = {
          statusCode: bodyContentError.status,
          message: ' Session timed out '
        };
      } else {
        errorContent = {
          statusCode: bodyContentError.status,
          message: bodyContentError.error ? bodyContentError.error : ''
        };
      }
      return observableThrowError(errorContent);
    }
  }
}
